import { IRazonModeloCommandCreate, IRazonModeloCommandEliminar, IRazonModeloRequest } from "../../Interfaces/auxiliar/IRazonModelo";
import { fetchListVerificacion } from "../http-common";

const razonModelo = "RazonModelo";

const TablaRazonModelo = (request: IRazonModeloRequest) => {
    return fetchListVerificacion.post(`${razonModelo}/ListarbyRazon`, request);
};

const CrearRazonModelo = (command: IRazonModeloCommandCreate) => {
    return fetchListVerificacion.post(`${razonModelo}/Crear`, command);
};

const EliminarRazonModelo = (command: IRazonModeloCommandEliminar) => {
    return fetchListVerificacion.delete(`${razonModelo}/Eliminar`, {
        params: command,
        // signal: controller.signal
    });
}

const RazonModeloService = {
    TablaRazonModelo,
    CrearRazonModelo,
    EliminarRazonModelo
}

export default RazonModeloService;